<template>
  <div style="max-width: 700px; height: 1400px">
    <form-wrapper ref="form">
      <v-row class="mt-1">
        <v-col cols="12" md="6" class="py-0">
          <input-field
            rules="required"
            @input="$emit('input', form)"
            label="Title"
            v-model="form.fax_title"
          ></input-field>
        </v-col>
        <template v-if="isSendFaxAdmin">
          <v-col cols="12" md="6" class="py-0">
            <input-field
              outlined
              dense
              label="To"
              v-model="form.to"
            ></input-field>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <input-field
              disabled
              label="From (Select Customer)"
              :value="customer.name"
            ></input-field>
          </v-col>
        </template>
        <v-col cols="12" md="6" class="py-0">
          <select-field
            item-text="template_name"
            label="Template"
            disabled
            :items="templates"
            :value="value.template"
          />
        </v-col>
        <v-col cols="12" class="py-0">
          <template-editor
            label="Message"
            v-model="form.cover_letter_message"
            @input="$emit('input', form)"
            minHeight="250px"
            v-if="isSendFaxAdmin"
          ></template-editor>
          <template v-else>
            <label>Cover Letter</label>
            <v-card
              flat
              width="100%"
              class="fax-preview pa-4 mb-4 grey lighten-2"
              v-html="formatMessage(form.cover_letter_message)"
            ></v-card>
          </template>
        </v-col>
      </v-row>
      <div class="subtitle-1 font-weight-bold">Documents you’ve selected</div>
      <div v-for="(item, i) in value.files" :key="i" style="max-width: 400px">
        <div class="ml-3">
          <div class="d-flex pa-2 align-center justify-space-between">
            <div>
              <v-icon>mdi-file</v-icon>
              <v-btn
                text
                @click="openFile(item)"
                :disabled="isDisabled(item)"
                class="subtitle-2 text-truncate pa-0 primary--text text-none"
              >
                {{ formatName(item.name) }}
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
        </div>
      </div>

      <v-card outlined class="dl-preview pa-4" v-if="dlDialog">
        <div class="d-flex">
          <div class="title">Preview of DL/SSN File</div>
          <v-spacer></v-spacer>
          <v-btn icon color="red" @click="dlDialog = false">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <v-card-text class="pa-0">
          <iframe :src="`${dl.url}#navpanes=0`" style="object-fit: contain" />
        </v-card-text>
      </v-card>
      <div class="mt-3 d-flex align-center pl-1">
        <template v-if="isSendFaxAdmin">
          <custom-menu @submit="submit($event)" v-if="hasEdit('send-faxes')">
            <v-btn
              class="mr-3 primary"
              depressed
              id="review-menu-button"
              height="40px"
              v-if="hasEdit('send-faxes')"
              :loading="loading"
              :disabled="loading"
              >Submit
              <v-icon right>
                {{ menu ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon
              >
            </v-btn>
          </custom-menu>
        </template>

        <v-btn
          outlined
          height="40px"
          color="red"
          :disabled="loading"
          @click="$emit('back')"
          >Back</v-btn
        >
        <v-btn
          outlined
          height="40px"
          color="red"
          class="ml-3"
          :disabled="loading"
          @click="close()"
          >Close</v-btn
        >
      </div>
    </form-wrapper>
  </div>
</template>

<script>
import TemplateEditor from "@/components/ui/TemplateEditor.vue";
import rulesConstants from "@/assets/constants/rules.constants";
import {formatFax, formatUserLetter, getDate, isDLFile,} from "@/assets/utils/common.utils";
import InputField from "@/components/ui/form/InputField.vue";
import SelectField from "@/components/ui/form/SelectField.vue";
import FormWrapper from "@/components/ui/form/FormWrapper.vue";
import {httpsCallable} from "firebase/functions";
import {colFaxes, functions} from "@/assets/utils/firebase.utils";
import {doc, updateDoc} from "firebase/firestore";
import CustomMenu from "./CustomMenu.vue";

export default {
  components: {
    TemplateEditor,
    InputField,
    SelectField,
    FormWrapper,
    CustomMenu,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      menu: false,
      rules: [rulesConstants.required],
      dlDialog: false,
      dl: {},
      form: {
        fax_title: "",
        cover_letter_message: "",
        to: "",
      },
      loading: false,
    };
  },
  inject: [
    "templates",
    "customer",
    "faxId",
    "prevRoute",
    "clientId",
  ],
  computed: {
    message() {
      let customer = this.customer || {};
      let account_numbers = "";
      let accounts = this.value.accounts || [];
      accounts.forEach((i) => {
        account_numbers += `${i.name} ${i.account_number}<br/>`;
      });
      return formatFax({
        message: this.value.cover_letter,
        fields: { ...customer, account_numbers },
      });
    },
  },
  methods: {
    isDisabled({ name }) {
      if (this.isSendFaxAdmin) return false;
      return !isDLFile({ name });
    },
    formatMessage(message) {
      return formatUserLetter(message);
    },
    openFile({ url }) {
      if (url instanceof File == false) {
        window.open(url, "_blank");
      }
    },
    formatName(name) {
      name = name.split(".")[0];
      if (name.length > 34) {
        return name.substr(0, 35) + "...";
      }
      return name;
    },
    openDL() {
      const vm = this;
      let dl = (vm.value.files || []).find((i) => isDLFile(i));
      if (dl) {
        vm.dl = dl;
        vm.dlDialog = true;
      }
    },
    // `type` is the delivery method picked in the Submit menu.
    async submit(type) {
      try {
        this.loading = true;
        await updateDoc(doc(colFaxes, this.faxId), {
          ...this.form,
          updated_at: getDate(),
          last_step: 3,
        });
        let manageLetter = httpsCallable(functions, "manageLetter");
        await manageLetter({ action: "print", data: { id: this.faxId, type } });
        this.notifySuccess("Letter has been submitted successfully.");
        this.close();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      if (this.prevRoute != null) {
        let client = this.prevRoute.matched.find(
          (i) => i.name == "client-dashboard"
        );
        if (client) {
          this.$router.replace({
            name: "client-dispute-letters",
            params: {
              id: this.clientId,
            },
          });
        } else {
          this.$router.replace("/dispute-letters");
        }
      } else {
        this.$router.replace("/dispute-letters");
      }
    },
  },
  mounted() {
    Object.keys(this.form).forEach((key) => {
      if (this.value[key] != undefined) {
        this.form[key] = this.value[key];
      }
    });
    this.openDL();
  },
};
</script>

<style lang="scss">
.dl-preview {
  width: 600px;
  height: calc(100vh - 210px);
  background: red;
  position: fixed;
  right: 20px;
  top: 120px;
  bottom: 0;
  margin: auto 0;
  iframe {
    border: none;
    width: calc(600px - 30px);
    height: calc(100vh - 280px);
  }
}
</style>
